import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styled from 'styled-components';

const SAFE_LINK = /^https?:\/\//i;

/** Markdown simples dentro dos componentes (cartões, abas): sem HTML,
 *  links só http(s) e abrindo em outra aba. */
function Markdown({ children }: { children: string }) {
  return (
    <Body>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children: c }: any) => (SAFE_LINK.test(href || '')
            ? <a href={href} target="_blank" rel="noopener noreferrer">{c}</a>
            : <span>{c}</span>),
          img: () => null,
        }}
      >
        {children || ''}
      </ReactMarkdown>
    </Body>
  );
}

export default Markdown;

const Body = styled.div`
  font-size: 0.86rem;
  line-height: 1.55;
  p { margin: 0 0 6px; }
  p:last-child { margin-bottom: 0; }
  ul, ol { margin: 4px 0 6px; padding-left: 20px; }
  li { margin: 2px 0; }
  a { color: ${({ theme }) => theme.prompt_accent_color || '#1a3c34'}; }
  table { border-collapse: collapse; font-size: 0.82rem; margin: 6px 0; }
  th, td { border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.12)')}; padding: 4px 8px; }
  code { font-size: 0.82em; padding: 1px 4px; border-radius: 4px; background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)')}; }
`;
